module.exports = __webpack_public_path__ + "img/activity.6f2fef49.svg";